// extracted by mini-css-extract-plugin
export default {"pagination":"StorePagination_pagination__-pNvw","arrow":"StorePagination_arrow__2N7rw","label":"StorePagination_label__cxFYV"};